/* eslint-disable camelcase */
import React from 'react'
import dayjs from 'dayjs'
import { CbSubscription } from '@lmc/common/types'
import Text from '../../../../../atoms/Text'

type BillingDateProps = {
  sub: CbSubscription
}

export const BillingDate = ({ sub }: BillingDateProps) => {
  // @ts-ignore
  if (sub.due_invoices_count > 0) {
    return (
      <>
        <Text as="p1" color="red" test-id="overdue">
          Overdue
        </Text>
        <br />
        <Text as="p2" color="darkgrey">
          {/* @ts-ignore */}
          {dayjs.unix(sub.due_since).format('DD-MM-YY')}
        </Text>
      </>
    )
  }

  if (sub.next_billing_at) {
    return <Text>{dayjs.unix(sub.next_billing_at).format('DD-MM-YY')}</Text>
  }

  return (
    <Text color="darkgrey" test-id="emptyState">
      Nothing here
    </Text>
  )
}

export default BillingDate
